// ENG-4154: read the IdentityState store; `force` maps to the store's pull primitive.
import { resolveLinkedAgentId } from '#~/electron/index.js';
import { Centered } from '@studio/design-system/overlay';
import { Spinner } from '@studio/design-system/spinner';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import { useEffect, type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

let bridgeIDInterval: NodeJS.Timeout | null = null;
let mainTimeout: NodeJS.Timeout | null = null;
let redirectTimeout: NodeJS.Timeout | null = null;

/** `<Restart>` component. */
export const Linking = (): ReactElement => {
  const navigate = useNavigate();

  const checkBridgeID = async () => {
    console.log('Checking for linked bridge ID...');
    const id = await resolveLinkedAgentId(true);

    if ((id?.length ?? 0) === 0) {
      return;
    }

    if (mainTimeout != null) {
      clearTimeout(mainTimeout);
      mainTimeout = null;
    }

    if (bridgeIDInterval != null) {
      clearInterval(bridgeIDInterval);
      bridgeIDInterval = null;
    }

    if (redirectTimeout != null) {
      return;
    }

    redirectTimeout = setTimeout(() => {
      navigate(`/agent/${id}`);
    }, 1000 * 3); // wait 3 seconds
  };

  useEffect(() => {
    if (mainTimeout != null) {
      return;
    }

    mainTimeout = setTimeout(() => {
      bridgeIDInterval = setInterval(() => {
        checkBridgeID();
      }, 1000 * 1); // search every second
    }, 1000 * 3); // wait 3 seconds

    return () => {
      if (mainTimeout != null) {
        clearTimeout(mainTimeout);
        mainTimeout = null;
      }
      if (bridgeIDInterval != null) {
        clearInterval(bridgeIDInterval);
        bridgeIDInterval = null;
      }
    };
  }, []);

  return (
    <Centered>
      <div className='flex items-center gap-8 text-xl'>
        <Spinner /> Linking {vendorName()} Bridge...
      </div>
    </Centered>
  );
};
